import React from 'react';

/**
 * Enterprise-grade Loader Component
 * Displays a centered circular spinner for admin dashboard
 * Designed to appear in content area only, without affecting layout
 */
const Loader = ({ size = 'medium', fullScreen = false }) => {
    const sizeMap = {
        small: { spinner: 32, border: 3 },
        medium: { spinner: 48, border: 4 },
        large: { spinner: 64, border: 5 }
    };

    const { spinner: spinnerSize, border: borderWidth } = sizeMap[size] || sizeMap.medium;
    
    const containerStyle = fullScreen ? styles.fullScreenContainer : styles.container;

    return (
        <div style={containerStyle}>
            <div style={styles.loaderWrapper}>
                <div style={{
                    ...styles.spinner,
                    width: `${spinnerSize}px`,
                    height: `${spinnerSize}px`,
                    borderWidth: `${borderWidth}px`
                }}></div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        width: '100%',
        padding: '40px 20px',
    },
    fullScreenContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
    },
    loaderWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    spinner: {
        border: '4px solid #e4e6ef',
        borderTopColor: '#3699ff',
        borderRadius: '50%',
        animation: 'spin 0.8s linear infinite',
    },
};

// Add keyframe animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

if (!document.getElementById('loader-animations')) {
    styleSheet.id = 'loader-animations';
    document.head.appendChild(styleSheet);
}

export default Loader;
